import { useState, useCallback } from 'react';

export function useLocalStorageTab(key: string, defaultValue: string) {
  const [value, setValue] = useState(() => {
    try {
      return localStorage.getItem(key) ?? defaultValue;
    } catch {
      return defaultValue
    }
  });

  const setTab = useCallback((next: string) => {
    setValue(next);
    try {
      localStorage.setItem(key, next);
    } catch {
    }
  }, [key]);

  return [value, setTab] as const
}
